module.exports = __webpack_public_path__ + "media/common/images/hirelocalelectricians.com.au/image5-b065bdefdfd82f089f65cc915d68a7d4.png";